import { useEffect, useState } from "react";
import ProductService from "../../Services/ProductService";

export interface ProductPricing {
  productTypeId: number;
  startingPrice: number | null;
}

// Resolves each keyword to a product type by name, then takes the lowest price from its product list
export default function useProductPricing(keywords: string[]) {
  const [pricing, setPricing] = useState<Record<string, ProductPricing>>({});

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      const types: { productTypeID: number; productTypeName: string }[] =
        (await ProductService.GetProductTypes()) || [];

      await Promise.all(
        keywords.map(async (keyword) => {
          const type = types.find((t) => t.productTypeName.toLowerCase().includes(keyword));
          if (!type) return;
          let startingPrice: number | null = null;
          try {
            const products = await ProductService.getProductList(type.productTypeID);
            const prices = products.map((p) => p.basePrice).filter((n) => typeof n === "number");
            if (prices.length) startingPrice = Math.min(...prices);
          } catch {
            // price stays null and the card shows a dash
          }
          if (!cancelled) {
            setPricing((prev) => ({ ...prev, [keyword]: { productTypeId: type.productTypeID, startingPrice } }));
          }
        })
      );
    };

    load().catch(() => undefined);
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return pricing;
}
